import { QABetaModuleProps } from '../types.ts';
import { UploadDocumentsForm } from './UploadDocumentsForm.tsx';
import { UploadedDocumentsInfo } from './UploadedDocumentsInfo.tsx';

type UploadDocumentsSectionProps = {
  qaAttempt: QABetaModuleProps['qaAttempt'];
  startQAMutation: QABetaModuleProps['startQAMutation'];
};

export function UploadDocumentsSection(props: UploadDocumentsSectionProps) {
  const { qaAttempt, startQAMutation } = props;
  const { status } = qaAttempt;

  if (status === 'idle') {
    return <UploadDocumentsForm startQAMutation={startQAMutation} />;
  }
  if (status === 'in-progress' || status === 'success' || status === 'error') {
    return <UploadedDocumentsInfo qaAttempt={qaAttempt} />;
  }

  throw new Error(`Invalid QA status '${status}'`);
}
